<template>
    <!-- Dashboard Cards  -->
     <div class="flex flex-wrap gap-4">
      <!-- pricing Package Cards -->
      <div v-show="subscribing" class="w-[calc(50%-0.5rem)] sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)] lg:w-[calc(33%-0.75rem)] !shadow-sm !border-0 card">
        <div class="card-body">
          <div class="flex justify-between">
            <span class="badge badge-md badge-xs badge-secondary">One Website</span>
            <span class="text-xl font-bold">$20<small class="font-normal">/mo</small></span>
          </div>
          <div class="flex justify-between">
            <div class="w-full">
            <h2 class="text-3xl font-bold">PRO</h2>
            </div>
          </div>
          <ul class="mt-6 flex flex-col gap-2 text-xs">
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4 me-2 inline-block text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              <span>Unlimited Slow Base Model Generations</span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4 me-2 inline-block text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              <span>150 Premium Model Generations</span>
            </li>
            <li class="tooltip tooltip-bottom" data-tip="Access to all Premium AI Models, Including GPT-4, Claude, and more..">
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4 me-2 inline-block text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              <span>SmartPress Moderator Access</span>
            </li>
            <li class="opacity-50">
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4 me-2 inline-block text-base-content/50" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              <span class="line-through">Use on multiple websites</span>
            </li>
          </ul>
          <div class="mt-6">
            <button @click="subscribe('PRO')" class="btn btn-primary btn-block ease-in-out transform hover:scale-105 transition duration-500" :disabled="isProcessingPRO">
            {{ isProcessingPRO ? 'Processing...' : 'Subscribe' }}
              <svg v-if="!isProcessingPRO" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
              </svg>
            </button>
            <p class="text-xs text-gray-500 text-center">7 Days Free Trial, Cancel Anytime.</p>
          </div>
        </div>
      </div>
      <div v-show="subscribing" class="w-[calc(50%-0.5rem)] sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)] lg:w-[calc(33%-0.75rem)] !shadow-sm !border-0 card">
        <div class="card-body">
          <div class="flex justify-between">
            <span class="badge badge-xs badge-secondary">Unlimited Websites</span>
            <span class="text-xl font-bold">$40<small class="font-normal">/mo</small></span>
          </div>
          <div class="flex justify-between">
            <div class="w-full">
            <h2 class="text-3xl font-bold">PRO Plus</h2>
            </div>
          </div>
          <ul class="mt-6 flex flex-col gap-2 text-xs">
            <li>
              <span>All <b>PRO</b> Features Plus:</span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4 me-2 inline-block text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              <span>Use on multiple websites</span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4 me-2 inline-block text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              <span>+150 Premium Generations (<b>300</b> Total)</span>
            </li>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" class="size-4 me-2 inline-block text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
              <span>Beta Features <span class="badge badge-xs bg-green-200 px-4">Image Generation</span></span>
            </li>
            
          </ul>
          <div class="mt-6">
            <button @click="subscribe('PRO-Plus')" class="btn btn-primary btn-block ease-in-out transform hover:scale-105 transition duration-500" :disabled="isProcessingPROPlus">
              {{ isProcessingPROPlus ? 'Processing...' : 'Subscribe' }}
              <svg v-if="!isProcessingPROPlus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
              </svg>
            </button>
            <p class="text-xs text-gray-500 text-center">7 Days Free Trial, Cancel Anytime.</p>
            
          </div>
        </div>
      </div>

      <!-- Hello Subscription Cards -->
       <!-- Large Card -->
      <div v-show="!subscribing" class="w-[calc(50%-0.5rem)] sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)] lg:w-[calc(25%-0.75rem)]">
        <div class="card w-full !shadow-sm !border-0 overflow-hidden">
          <div class="bg-gray-100 w-full h-68 rounded-box ">
            <!-- include the image -->
            <img :src="`${pluginUrl}/assets/smartpress-feature-1.png`" alt="SmartPress Logo" class="w-100 bottom-[40px] right-[10px] relative">
          </div>
          <div class="card-body mt-2">
            <h2 class="text-2xl font-bold">Welcome {{ wpUser.display_name }},</h2>
            <p class="text-sm text-gray-600 !mt-[0px]">Your Premium plan takes the heavy lifting for you with full access to <b>Advanced Features</b> — focus less on content and more on growth</p>
            <button class="btn btn-primary  ease-in-out transform hover:scale-105 transition duration-500" v-if="currentUser.plan === 'free'" @click="subscribing = true">Upgrade to PRO</button>
            <small class="text-xs text-gray-500" v-if="currentUser.plan === 'free'">7 Days Free Trial, Cancel Anytime.</small>
          </div>
        </div>
      </div>

      <!-- column 2 -->
      <div v-show="!subscribing" class="w-[calc(50%-0.5rem)] sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)] lg:w-[calc(25%-0.75rem)] flex flex-col gap-0">
        <div class="card w-full !shadow-sm !border-0 overflow-hidden h-70">
          <div class="flex h-full">
            
            <div class="card-body w-1/2 !p-2">
              <h2 class="text-lg font-bold">Premium Models</h2>
              <p class="text-xs text-gray-600"><b>Premium</b> models for advanced and more complex requests.</p>
            </div>
            <div class="w-1/2 bg-gray-100 rounded-box flex items-center justify-center ">
              <img :src="`${pluginUrl}/assets/smartpress-feature-2.png`" alt="SmartPress Feature" class="w-100 bottom-[-40px] right-[-40px] relative" style="image-rendering: -webkit-optimize-contrast; image-rendering: crisp-edges;">
            </div>
          </div>
        </div>
        <div class="card w-full !shadow-sm !border-0 overflow-hidden h-70">
          <div class="flex h-full">
            
            <div class="card-body w-1/2 !p-2">
              <h2 class="text-lg font-bold">Image Generation</h2>
              <p class="text-xs text-gray-600">Generate Images with a few clicks anywhere from wordpress <b>native</b> media manager.</p>
            </div>
            <div class="w-1/2 bg-gray-100 rounded-box flex items-center justify-center ">
              <img :src="`${pluginUrl}/assets/smartpress-feature-6.png`" alt="SmartPress Feature" class="w-100 bottom-[-40px] right-[-40px] relative" style="image-rendering: -webkit-optimize-contrast; image-rendering: crisp-edges;">
            </div>
          </div>
        </div>
      </div>

      <!-- column 3 -->
      <div v-show="!subscribing" class="w-[calc(50%-0.5rem)] sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)] lg:w-[calc(25%-0.75rem)] flex flex-col gap-0">
        <div class="card w-full !shadow-sm !border-0 overflow-hidden h-70">
          <div class="flex h-full">
            
            <div class="card-body w-1/2 !p-2">
              <h2 class="text-lg font-bold">Advanced Features</h2>
              <p class="text-xs text-gray-600">One click <b>Enhance prompt</b>, Templates, History, and more.</p>
            </div>
            <div class="w-1/2 bg-gray-100 rounded-box flex items-center justify-center ">
              <img :src="`${pluginUrl}/assets/smartpress-feature-7.png`" alt="SmartPress Feature" class="w-100 bottom-[-30px] right-[-40px] relative" style="image-rendering: -webkit-optimize-contrast; image-rendering: crisp-edges;">
            </div>
          </div>
        </div>
        <div class="card w-full !shadow-sm !border-0 overflow-hidden h-70">
          <div class="flex h-full">
            
            <div class="card-body w-1/2 !p-2">
              <h2 class="text-lg font-bold">SmartChat</h2>
              <p class="text-xs text-gray-600">Manage content or handle advanced tasks — <b>faster, smarter, and hands-free</b>.</p>
            </div>
            <div class="w-1/2 bg-gray-100 rounded-box flex items-center justify-center ">
              <img :src="`${pluginUrl}/assets/smartpress-feature-9.png`" alt="SmartPress Feature" class="w-100 bottom-[-20px] right-[-40px] relative" style="image-rendering: -webkit-optimize-contrast; image-rendering: crisp-edges;">
            </div>
          </div>
        </div>
      </div>
      
      <!-- SmartPress Account Card -->
      <div class="w-[calc(50%-0.5rem)] sm:w-[calc(50%-0.5rem)] md:w-[calc(33.333%-0.67rem)] lg:w-[calc(25%-0.75rem)] card !shadow-sm !bg-secondary !text-secondary-content !p-0 !border-0 overflow-hidden">
        <figure class="bg-primary !w-full !m-0 min-h-12 !flex !items-center !justify-between !rounded-t-lg">
          <h2 class="!text-secondary-content pl-4 font-bold">SmartPress Account</h2>
         
          <img
            :src="`${pluginUrl}/assets/smart-press-logo.png`"
            alt="Smartpress Logo"
            class="w-10 px-2 py-2"/>
        </figure>
        
        <div class="card-body !p-8">
          <p class="mb-4 text-base">SmartPress is active, Wordpress Just got Smarter!</p>

        <form @submit.prevent="updateAccount">
          <fieldset class="fieldset tooltip tooltip-top rounded-lg border border-opacity-10 p-3" data-tip="To change your email address, Logout from Account Menu on top right corner.">
            <legend class="px-2 font-medium">Email Address:</legend>
            <input type="text" class="input !border-0 !font-bold w-full bg-secondary-focus bg-opacity-20 rounded-md" v-model="customFields.email" placeholder="Account Email" :disabled="!updateAccount"/>
          </fieldset>
          <p v-if="updateAccount" class="text-xs text-gray-500 mt-2">An Email will be sent to your email address to verify the account and sign you in.</p>
          
          
          
          <fieldset class="fieldset !mt-6 rounded-lg border border-opacity-10 p-3" v-if="!updateAccount && customFields.email && customFields.api_key && currentUser.$id">
            <div class="flex items-center justify-between mb-2">
              <legend class="px-2 font-medium">Basic Requests Usage:</legend>
              <span class="text-xs text-gray-400 font-medium">{{currentUser.basic_requests}} / {{currentUser.plan === "free" ? currentUser.basic_limit : '∞'}}</span>
            </div>
            <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <!-- Width is the percentage of tokens used -->
            <div class="bg-primary h-2.5 rounded-full" :style="{width: currentUser.plan != 'free' ? '100%' : ((currentUser.basic_requests / currentUser.basic_limit) * 100) + '%'}"></div>
            </div>          
        </fieldset>

        <fieldset class="fieldset !mt-6 rounded-lg border border-opacity-10 p-3" v-if="!updateAccount && customFields.email && customFields.api_key && currentUser.$id">
            <div class="flex items-center justify-between mb-2">
              <legend class="px-2 font-medium">Premium Requests Usage:</legend>
              <span class="text-xs text-gray-400 font-medium">{{currentUser.premium_requests}} / {{currentUser.premium_limit}}</span>
            </div>
            <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
            <!-- Width is the percentage of tokens used -->
            <div class="bg-primary h-2.5 rounded-full" :style="{width: currentUser.premium_limit > 0 ? ((currentUser.premium_requests / currentUser.premium_limit) * 100) + '%' : '0%'}"></div>
            </div>          
        </fieldset>

         

          <div class="!mt-6 bg-opacity-20 rounded-lg p-4 border border-gray-700 py-0 pb-4" v-if="!updateAccount && customFields.email && customFields.api_key && currentUser.$id">
            <div class="flex items-center justify-between mb-2">
              <h4 class="font-medium text-base !text-white">Active Plan</h4>
              <div class="badge badge-sm border-0" :class="currentUser.plan === 'free' ? 'bg-green-100 text-green-800' : 'bg-green-200 text-green-900'">
                {{ currentUser.plan.toUpperCase() }}
              </div>
            </div>
            <div class="flex items-center mt-3" v-if="daysUntilRenewal !== 'Expired'">
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="size-4 text-gray-300 mt-[-2px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span class="text-xs font-light" >Renews in <b class="text-primary-content">{{daysUntilRenewal}}</b></span>
              </div>
            </div>
          </div>
        </form>
          
          <div class="card-actions justify-end items-center mt-6">
            <button class="btn btn-sm rounded-md" @click="updateAccount = false" v-if="updateAccount">Cancel</button>
            <!-- <button class="btn btn-primary" @click="changeAccount">{{!updateAccount ? 'Update Account' : 'Sign in'}}</button> -->
          </div>
        </div>
      </div>

    </div>

    <smartChat />
</template>

<script>
import axios from 'axios';
import smartChat from './smart-press/smartChat.vue';

export default {
  name: 'AdminDashboard',
  components: {
    smartChat
  },
  data() {
    return {
      currentUser: localStorage.getItem('smartpress_current_user') ? JSON.parse(localStorage.getItem('smartpress_current_user')) : {},
      customFields: localStorage.getItem('smartpress_custom_fields') ? JSON.parse(localStorage.getItem('smartpress_custom_fields')) : {},
      loading: true,
      saving: false,
      error: null,
      saveSuccess: false,
      updateAccount: false,
      isProcessingPRO: false,
      isProcessingPROPlus: false,
      wpUser: window.smartpress_wpUserData ? window.smartpress_wpUserData : {},
      subscribing: false,
      pluginUrl: window.smartpress_vars.pluginUrl || '',
    }
  },
  created() {
    if(this.customFields.api_key){
      this.getUserDetails();
    }else{
      this.signOut();
    }
  },
  mounted(){
  
  },
  methods: {
    async getUserDetails(retry = 0){
    const response = await axios.post('https://67d16eab6a70f6dfc533.10g8.cloud/whoami', {
      session: this.customFields.api_key
    });
    if(response.data.success){
      this.currentUser = response.data.user;
      localStorage.setItem('smartpress_current_user', JSON.stringify(this.currentUser));
    }else{
      // retry the request 2 more times
      if(retry < 2){
        setTimeout(() => {
          this.getUserDetails(retry + 1);
        }, 1000);
      }else{
        this.signOut();
      }
    }
    },
    async changeAccount(){
    if(!this.updateAccount){
    this.updateAccount = true;
    }else{
      // udpate custom fields
      this.customFields={
        email: this.customFields.email,
        sites: [],
        api_key: '',
        license: ''
      }
      this.currentUser = {};
      // send the actual request to server to udpate account
      this.updateAccount = false;
    }
    },
    signOut(){
      this.customFields={};
      this.currentUser={};
      localStorage.removeItem('smartpress_current_user');
      localStorage.removeItem('smartpress_custom_fields');
    },
    subscribe(plan){
      if (plan === 'PRO') {
        this.isProcessingPRO = true;
      } else if (plan === 'PRO-Plus') {
        this.isProcessingPROPlus = true;
      }
      
      axios.post('https://67d16eab6a70f6dfc533.10g8.cloud/subscribe', {
        plan: plan,
        session: this.customFields.api_key,
        domain: window.smartpress_wpUserData.site_url
      }).then(response => {
        console.log(response);
        if(response.data.success){
          console.log(response.data.checkoutSession.url);
          window.open(response.data.checkoutSession.url, '_blank');
        }
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        if (plan === 'PRO') {
          this.isProcessingPRO = false;
        } else if (plan === 'PRO-Plus') {
          this.isProcessingPROPlus = false;
        }
      });
    }
  },
  computed: {
    daysUntilRenewal() {
      const endDate = new Date(this.currentUser.subscription_end);
      const today = new Date();
      const timeDiff = endDate - today;
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)); // Convert milliseconds to days

      if (daysDiff < 0) {
        return 'Expired';
      } else if (daysDiff === 0) {
        return 'Today';
      } else if (daysDiff === 1) {
        return '1 day';
      } else {
        return `${daysDiff} days`;
      }
    }
  }
}
</script>

<style scoped>


</style> 